import { LOAD_NEW_RULE } from '../constants'

export default rule => ({
    type: LOAD_NEW_RULE,
    rule
})
